import { render, staticRenderFns } from "./ClassStudentListModal.vue?vue&type=template&id=7ffb1cf8"
import script from "./ClassStudentListModal.vue?vue&type=script&lang=js"
export * from "./ClassStudentListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports